// extracted by css-extract-rspack-plugin
export default {"cls1":"ContentFeedback-cls1_pP5","cls2":"ContentFeedback-cls2_3US ContentFeedback-cls1_pP5"};